import styled from 'styled-components';
import config from '../../../config';
const { desktopMinWidth } = config;

export const PageLayout = styled.div`
  width: auto;
  height: 100vh;
  display: flex;
  align-items: center;
  text-align: center;
  padding: 0 24px;
`;

export const GridLayout = styled.div`
  height: 100%;
  width: 100%;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    height: auto;
    width: 1168px;
    
    display: grid;
    grid-template-columns: repeat(8, 132px);
    grid-column-gap: 16px;

    margin: 0 auto;
    padding: 0 16px;
  }
`;

/**
 * Coinplug logo container
 */
export const LogoContainer = styled.div`
  margin-top: 56px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    margin-top: 32px;
    grid-column: 4 / 6;
  }
`;

/**
 * Coinplug logo style
 */
export const Logo = styled.img`
  height: 24px;
`;

export const PageTitle = styled.div`
  /* var(--font) 는 public/index.html 에 정의되어 있음 */
  font-family: var(--font);
  font-size: 40px;
  font-weight: 400;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.87);
  margin-top: 108px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    font-size: 60px;
    grid-column: 2 / 8;
  }
`;

export const Paragraph = styled.div`
  /* var(--font) 는 public/index.html 에 정의되어 있음 */
  font-family: var(--font);
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 48px;
  display: none; /* 모바일에서는 보이지 않게 */
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    font-size: 24px;
    grid-column: 2 / 8;
    display: block; /* pc 에서는 보이게 */
  }
`;

export const ResultBoxContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  margin-bottom: 32px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    position: relative;
    grid-column: 2 / 8;
    margin: 74px 0 32px 0;
  }
`;

export const ResultBoxWrapper = styled.div`
  padding: 0 24px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    width: 576px;
    padding: 0;
    margin: 0 auto;
  }
`;
